var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    fill: "#888",
    stroke: "#fff",
    strokeWidth: 2,
    rx: 7,
    ry: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fill: "#FFF",
    fontSize: 16
  }, /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 21,
    fontWeight: "bold"
  }, "\u4ED6"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOther);
export default __webpack_public_path__ + "static/media/marker_other.52f1ae07d9232b3821aa4656f91ff25d.svg";
export { ForwardRef as ReactComponent };